module.exports = __webpack_public_path__ + "img/mor-read_03.13076e5c.jpg";